import Page404 from '@pages/Page404.svelte'
import PageHome from '@pages/PageHome.svelte'

export const routes = [
  {
    path: '/',
    page: PageHome,
  },
  {
    meta: {
      title: '404',
    },
    path: '*',
    page: Page404,
  },
]

